module.exports = __webpack_public_path__ + "static/media/meest-bg.5eda79b9.jpg";